import axiosNest from '../../api/axiosNest';

/**
 * Pulpit Trade — odpowiada `GET /trade-dashboard` w API (makieta back office
 * v2, A9; przełącznik `tradeDashboard`, 20.10.2026). API oddaje przy każdej
 * liczbie FILTR listy zleceń, którym ją policzyło — kafelek prowadzi do listy
 * z dokładnie tym filtrem, więc liczba i lista się zgadzają.
 */

/** Przełącznik funkcji — klucz z rejestru API (dane, nie przemianowujemy). */
export const FEATURE_TRADE_DASHBOARD = 'tradeDashboard';
/** Alert przed załadunkiem (12.10.2026) — filtr „jutro załadunek” bez niego jest pusty. */
export const FEATURE_LOADING_TOMORROW_ALERT = 'loadingTomorrowAlert';

export interface TradeDashboardTile {
  key: string;
  count: number;
  filter: Record<string, unknown>;
}

export interface TradeDashboardSummary {
  tiles: TradeDashboardTile[];
  computedAt: string;
}

/** Napisy kafelków — klucze jak w API (`trade-dashboard.ts`). */
export const TRADE_TILE_TEXT: Record<
  string,
  { label: string; description: string; highlight?: 'uwaga' | 'ostrzezenie' }
> = {
  handedToTrade: {
    label: 'Przekazane do Trade',
    description: 'czekają na przewoźnika',
  },
  withOffers: {
    label: 'Z ofertami przewoźników',
    description: 'przekazane, z otwartą ofertą — do decyzji tradera',
    highlight: 'uwaga',
  },
  withoutOffers: {
    label: 'Bez ofert przewoźników',
    description: 'przekazane, bez otwartej oferty',
  },
  // Paczka p. Mariusza 21.10, S-21.10-17: przypomnienie o wpisie w TMS.
  carrierAcceptedAwaitingTms: {
    label: 'Przewoźnik zaakceptowany — czeka na TMS',
    description: 'wpisz przewoźnika w TMS; „sprzedane” ustawi import',
    highlight: 'uwaga',
  },
  loadingTomorrow: {
    label: 'Jutro załadunek, bez przewoźnika',
    description: 'alert z przeglądu o 15:00 dzień przed załadunkiem',
    highlight: 'ostrzezenie',
  },
  postedOnExchange: {
    label: 'Na giełdzie',
    description: 'zlecenia Trade z ofertą na giełdzie',
  },
  forSale: {
    label: 'Do sprzedaży',
    description: 'STANDARD i MEGA w planowaniu — rekomendacja, przekazuje człowiek',
  },
  returnedToFtl: {
    label: 'Zwrócone do FTL',
    description: 'wróciły z Trade i czekają w FTL na pojazd',
  },
  carrierAssigned: {
    label: 'Obsadzone przewoźnikiem',
    description: 'przewoźnik wpisany w TMS',
  },
};

export async function fetchTradeDashboard(): Promise<TradeDashboardSummary> {
  const { data } = await axiosNest.get<TradeDashboardSummary>('/trade-dashboard');
  return { tiles: Array.isArray(data?.tiles) ? data.tiles : [], computedAt: data?.computedAt ?? '' };
}
